// import React from 'react';

// const ListBlock = ({ block, onChange }) => {
//   const updateItem = (index, value) => {
//     const updated = [...block.items];
//     updated[index] = value;
//     onChange({ ...block, items: updated });
//   };

//   const addItem = () => {
//     onChange({ ...block, items: [...block.items, ''] });
//   };

//   const removeItem = (index) => {
//     const updated = [...block.items];
//     updated.splice(index, 1);
//     onChange({ ...block, items: updated });
//   };

//   return (
//     <div>
//       {block.items.map((item, i) => (
//         <div key={i}>
//           <input
//             value={item}
//             onChange={(e) => updateItem(i, e.target.value)}
//             placeholder={`List item ${i + 1}`}
//           />
//           <button onClick={() => removeItem(i)}>🗑️</button>
//         </div>
//       ))}
//       <button onClick={addItem}>Add Item</button>
//     </div>
//   );
// };

// export default ListBlock;

import React from 'react';
import FormattingToolbar from './FormattingToolbar';

const ListBlock = ({ block, onChange }) => {
  const updateItem = (index, value) => {
    const updated = [...block.items];
    updated[index] = value;
    onChange({ ...block, items: updated });
  };

  const addItem = () => {
    onChange({ ...block, items: [...block.items, ''] });
  };

  const removeItem = (index) => {
    const updated = [...block.items];
    updated.splice(index, 1);
    onChange({ ...block, items: updated });
  };

  const applyFormat = (index, tag) => {
    const selected = window.getSelection();
    const text = selected.toString();

    if (!text) return;

    const textarea = document.getElementById(`list-item-${index}`);
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const before = block.items[index].substring(0, start);
    const after = block.items[index].substring(end);
    const formatted = `<${tag}>${text}</${tag}>`;
    const newText = before + formatted + after;

    updateItem(index, newText);
  };

  return (
    <div>
      {block.items.map((item, i) => (
        <div key={i} style={{ marginBottom: '12px' }}>
          <FormattingToolbar onFormat={(tag) => applyFormat(i, tag)} />
          <textarea
            id={`list-item-${i}`}
            value={item}
            onChange={(e) => updateItem(i, e.target.value)}
            placeholder={`List item ${i + 1}`}
            rows={2}
            style={{ width: '100%', padding: '6px', borderRadius: '6px', border: '1px solid #ccc' }}
          />
          <button onClick={() => removeItem(i)} style={{ marginTop: '4px' }}>🗑️ Remove</button>
        </div>
      ))}
      <button onClick={addItem} style={{ marginTop: '10px' }}>➕ Add Item</button>
    </div>
  );
};

export default ListBlock;
